import React from 'react';
import { gql } from 'apollo-boost';
import {
  Input, InputContainer, Calendar, withQuery,
} from 'components/common';
import sortDate from 'utils/sortDate';
import StatementsTable from './StatementsTable';
import { track } from '../../../utils/analytics';


function Statements({ data: { statements } }) {
  track('DASHBOARD_STATEMENTS_PAGE_LOADED');
  return (
    <>
      <div className="flex mx-auto self-center">
        <div className="flex flex-col flex-1">
          <h1 className="font-title text-2xl mb-2">Your Statements</h1>
          <div className="mb-2">
            <InputContainer className="flex flex-1 w-full">
              <div className="flex justify-between w-full">
                <Input placeholder="Search" />
                <i className="fas fa-search text-gray-secondary self-center" />
              </div>
            </InputContainer>
          </div>
          <div className="flex flex-col w-full sm:flex-row">
            <Calendar
              onCalendarError={(err) => {
                console.log('calendar error', err);
              }}
              onCalendarChange={(fromDate, toDate) => {
                console.log('on calendar change...', fromDate, toDate);
              }}
            />
            {/* <div className="w-full mt-3 sm:w-auto sm:mt-0 flex">
              <button className="btn w-full">Export</button>
            </div> */}
          </div>
          <StatementsTable className="" statements={sortDate(statements, 'end_date')} />
        </div>
      </div>
    </>
  );
}

const STATEMENTS_QUERY = gql`
  query Statements {
    statements {
      credits
      debits
      start_date
      end_date
      opening_balance
      ending_balance
      fees
      csv_url
      pdf_url
      nickname
      payment_due_date
      installment_amount
    }
  }
`;

export default withQuery(STATEMENTS_QUERY)(Statements);
